import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'App/styled';
import BackArrowIcon from 'components/Icons/BackArrow';
import { pushEvent } from 'helpers/utils/dataLayer';
import { goTopTop } from 'shared/constants';
import { State } from 'store/types';

const SHOW_BACK_TO_TOP_THRESHOLD = 200;

const BackToTopButton = styled.button<{ bottomPosition: number }>`
  position: fixed;
  border: none;
  bottom: ${({ bottomPosition }) => `${bottomPosition}px`};
  right: 10px;
  z-index: 5;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.4);

  &::focus {
    outline: none;
  }

  svg {
    transform: rotate(90deg);
  }
`;

function BackToTop() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  const { backToTopPosition = 50 } = useSelector(
    (state: State) => state.appReducer
  );

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showBackToTop && window.pageYOffset > SHOW_BACK_TO_TOP_THRESHOLD) {
        setShowBackToTop(true);
      } else if (
        showBackToTop &&
        window.pageYOffset <= SHOW_BACK_TO_TOP_THRESHOLD
      ) {
        setShowBackToTop(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop, { passive: true });
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  });

  const handleBackToTop = (event: React.MouseEvent) => {
    event.preventDefault();
    pushEvent(goTopTop, {});
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  if (showBackToTop) {
    return (
      <BackToTopButton
        bottomPosition={backToTopPosition}
        onClick={handleBackToTop}
      >
        <BackArrowIcon />
      </BackToTopButton>
    );
  }
  return null;
}

export default BackToTop;
